export default {
  BASE_URL: '//bidding-service-01.int.myfth.in',
};
